import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Breadcrumb } from './breadcrumb.component';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  public breadcrumbs$: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject<Breadcrumb[]>([]);

  append(description: string, link: string = '') {

    let breadcrumbList = [];
    if (description != ""){
      let breadCrumb : Breadcrumb = {
        description, link
      }    
      breadcrumbList.push(breadCrumb);
    }
    this.appends(breadcrumbList);
  }

  appends(breadCrumbs : Breadcrumb[]) {
    this.breadcrumbs$.next(breadCrumbs);
  }

  reset() {
    this.breadcrumbs$.next([]);
  }
  
}
